import { Pipe, PipeTransform } from '@angular/core';
import { InstrumentType, OrderData } from '@zero/shared/util-models';

@Pipe({
  name: 'shorthandSymbol',
  standalone: true,
})
export class ShorthandSymbolPipe implements PipeTransform {
  public transform(value: OrderData, prop?: string): string {
    const fallback = value.instrumentType === InstrumentType.Crypto ? 'shortName' : 'isin';
    return value[prop ?? fallback];
  }
}
